<template>
  <div class="tab-configuration__wrapper flex">
    <div class="tab-configuration__tabs-menu flex justify-between">
      <button v-for="t in tabs"
              :key="t.id"
              v-text="t.title"
              :class="currentTab === t.id ? 'active-tab' : ''"
              class="uppercase inline-block mr-4 tabs-menu__item"
              @click="currentTab = t.id"></button>
    </div>
    <div class="tab-configuration__tabs">

      <transition name="fade">
        <dress-carousel :items="clothes" v-if="currentTab === 1"></dress-carousel>
      </transition>


      <!--fabric carousel-->
      <transition name="fade">

        <div v-if="currentTab === 2">
          <mesh-select></mesh-select>

          <fabric-carousel v-if="!meshIsAccessory(selectedMesh)" :items="fabrics" ></fabric-carousel>
          <p v-else class="text-center mb-6">Can not set fabric for this selection</p>
        </div>

      </transition>


      <!--textures carousel-->
      <transition name="fade">
        <div v-if="currentTab === 3">
          <mesh-select></mesh-select>

          <texture-carousel v-if="!meshIsAccessory(selectedMesh)" :items="textures" ></texture-carousel>
          <p v-else class="text-center mb-6">Can not set texture for this selection</p>
        </div>

      </transition>


      <!--settings-->
      <transition name="fade">
        <div v-if="currentTab === 4">
          <mesh-select class="mb-5"></mesh-select>

          <texture-transform-selectors v-if="!meshIsAccessory(selectedMesh)"></texture-transform-selectors>
          <p v-else>Settings not available for accessories.</p>
        </div>

      </transition>
    </div>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import DressCarousel from '../partials/DressCarousel';
  import TextureCarousel from '../partials/TextureCarousel';
  import FabricCarousel from '../partials/FabricCarousel';
  import MeshSelect from '../selectors/MeshSelectorSelectInput'
  import TextureTransformSelectors from '../selectors/TextureTransformSelectors'

  export default {
    name: "TabConfiguration",
    components: {
      TextureCarousel,
      DressCarousel,
      FabricCarousel,
      MeshSelect,
      TextureTransformSelectors,
    },
    data() {
      return {
        tabs: [
          {
            id: 1,
            title: 'model',
          },
          {
            id: 2,
            title: 'fabric',
          },
          {
            id: 3,
            title: 'design',
          },
          {
            id: 4,
            title: 'settings',
          }
        ],
        currentTab: 1,
      }
    },
    computed: {
      ...mapGetters('clothes',[
        'clothes'
      ]),
      ...mapGetters('fabrics',[
        'fabrics'
      ]),
      ...mapGetters('textures',[
        'textures'
      ]),
      ...mapGetters('clothes',[
        'selectedMesh'
      ]),
      ...mapGetters('objects3d',[
        'meshIsAccessory'
      ]),
    }
  }
</script>

<style scoped>
  .tab-configuration__wrapper {
    flex-direction: column-reverse;
  }


  .tabs-menu__item {
    font-weight: 500;
    position: relative;
    transition: all 0.2s ease-in-out;
    padding-right: 10px;
    color: #7C7C7C;
    font-size: 14px;
  }

  /*.tabs-menu__item::after {*/
  /*content: '';*/
  /*height: 100%;*/
  /*width: 1px;*/
  /*background-color: #7C7C7C;*/
  /*display: block;*/
  /*position: absolute;*/
  /*top: 0;*/
  /*right: 0px;*/
  /*}*/
  .tabs-menu__item::after {
    content: '';
    height: 7px;
    width: 7px;
    transform-origin: center;
    transform: rotate(-45deg);
    border-right: 1px solid #7C7C7C;
    border-bottom: 1px solid #7C7C7C;
    /*background-color: #7C7C7C;*/
    display: block;
    position: absolute;
    top: 7px;
    right: -4px;
    transition: all 0.2s ease-in-out;
  }

  .tabs-menu__item:last-child {
    padding-right: 0;
  }

  .tabs-menu__item:last-child::after {
    display: none;
  }

  .tabs-menu__item.active-tab {
    color: red;
  }

  .tabs-menu__item.active-tab::after {
    border-color: red;
  }

  .fade-enter-active, .fade-leave-active {
    transition: all .5s;
  }

  .fade-leave-active {
    position: absolute;
    width: calc(100% - 40px );
    z-index: 10;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  /*.fade-leave-to {*/
    /*transform: translateY(50px);*/
  /*}*/

</style>